import { isFeatureEnabled } from '@lumapps/features';
import { isSuperAdmin } from '@lumapps/permissions';

import { NANNY_FEATURE_CODE } from '../constants';

const isNannyEnabled = isFeatureEnabled(NANNY_FEATURE_CODE);
const isNannyAllowed = isSuperAdmin;

export { isNannyEnabled, isNannyAllowed };
